export default function() {

  const tabs = document.querySelectorAll('[id^="tabs"]');
  tabs.forEach(function(el) {

    const tablist = el.querySelector('ul[role="tablist"]');
    const controls = tablist.querySelectorAll('[data-tab-control]');

    const switchTab = (oldTab, newTab) => {

      let oldIndex = parseInt(oldTab.getAttribute('data-tab-control'));
      let oldId = oldTab.getAttribute('id');
      let oldSection = el.querySelector('[data-tab-section="'+oldIndex+'"][aria-labelledby="'+oldId+'"]');

      oldTab.removeAttribute('aria-selected');
      oldTab.setAttribute('tabindex', '-1');
      oldSection.hidden = true;

      let newIndex = parseInt(newTab.getAttribute('data-tab-control'));
      let newId = newTab.getAttribute('id');
      let newSection = el.querySelector('[data-tab-section="'+newIndex+'"][aria-labelledby="'+newId+'"]');

      newTab.focus();
      newTab.removeAttribute('tabindex');
      newTab.setAttribute('aria-selected', true);
      newSection.hidden = false;

      if ((newTab.tagName == 'A') && (newTab.getAttribute('href') != '')) {

        let newTabState = { id: newTab.id };
        let newTabHref = newTab.getAttribute('href');
        let newTabHash = newTabHref.substring(newTabHref.indexOf('#'));
        let newTabUrl = (window.location.pathname + newTabHref);

        history.replaceState(newTabState, '', newTabUrl);

        if (newTabHash.startsWith('#')) {
          let targetSection = document.getElementById(newTabHash.substring(1));
          targetSection.scrollIntoView();
        }
      }
    }

    controls.forEach(function(control) {
      control.addEventListener('click', e => {
        e.preventDefault();

        let currentTab = tablist.querySelector('[aria-selected]');
        let firstTab = tablist.querySelector('[data-tab-control="1"]');

        if (!currentTab) {
          switchTab(firstTab, e.currentTarget);
        }

        else if (e.currentTarget !== currentTab) {
          switchTab(currentTab, e.currentTarget);
        }
      });

      control.addEventListener('keydown', e => {

        let oldTab = e.currentTarget;
        let oldIndex = parseInt(oldTab.getAttribute('data-tab-control'));

        let newIndex = (e.which === 37 ? (oldIndex - 1) : (e.which === 39 ? (oldIndex + 1) : (e.which === 40 ? oldIndex : null)));
        let newTab = el.querySelector('[data-tab-control="'+newIndex+'"]');
        let newSection = el.querySelector('[data-tab-section="'+newIndex+'"]');

        if (newIndex === oldIndex) {
          e.preventDefault();
          newSection.focus();
        }

        else if (newTab) {
          e.preventDefault();
          switchTab(oldTab, newTab);
        }
      });
    });
  });
}
